import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuthStore } from '../store/authStore.js';

export function RequireAdmin() {
  const user = useAuthStore((state) => state.user);
  const syncWithBackend = useAuthStore((state) => state.syncWithBackend);
  const isLoading = useAuthStore((state) => state.isLoading);
  useEffect(() => {
    if (user && user.role !== 'ADMIN') {
      void syncWithBackend();
    }
  }, [syncWithBackend, user]);

  useEffect(() => {
    if (user && !isLoading && user.role !== 'ADMIN') {
      toast.error('You do not have access to this area');
    }
  }, [isLoading, user]);
  if (!user) return <Navigate to="/login" replace />;
  if (isLoading) return null;
  if (user.role !== 'ADMIN') {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}
